import API_CONFIG from '../config/apiConfig.js';

const API_ENDPOINT = API_CONFIG.endpoint;
const COGNITO_TIMEOUT = 8 * 60 * 60 * 1000; // 8 hours

const AuthService = {
  async login(email, password) {
    const normalizedEmail = email.toLowerCase().trim();

    // Step 1: Cognito Authentication
    const cognitoResponse = await fetch(`${API_ENDPOINT}/v2/auth/cognito`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: normalizedEmail, password })
    });

    if (!cognitoResponse.ok) {
      const errorData = await cognitoResponse.json();
      throw new Error(errorData.error || 'Authentication failed');
    }

    const cognitoData = await cognitoResponse.json();

    // Step 2: Get Venue Access
    const venueResponse = await fetch(`${API_ENDPOINT}/v2/auth/venue-access`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${cognitoData.accessToken}`
      },
      body: JSON.stringify({ email: normalizedEmail, appId: 'launchpad' })
    });

    if (!venueResponse.ok) {
      const errorData = await venueResponse.json();
      throw new Error(errorData.error || 'Venue access failed');
    }

    const venueData = await venueResponse.json();

    // Store auth data
    localStorage.setItem('cognitoAccessToken', cognitoData.accessToken);
    localStorage.setItem('cognitoIdToken', cognitoData.idToken);
    localStorage.setItem('cognitoRefreshToken', cognitoData.refreshToken);
    localStorage.setItem('venueAccessToken', venueData.venueAccessToken);
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('email', normalizedEmail);
    localStorage.setItem('venueId', venueData.venueId);
    localStorage.setItem('venueName', venueData.venueName);
    localStorage.setItem('userRole', venueData.role);

    const staffName = venueData.firstName && venueData.lastName
      ? `${venueData.firstName} ${venueData.lastName}`
      : venueData.firstName || venueData.lastName || normalizedEmail.split('@')[0].toUpperCase();
    localStorage.setItem('staffName', staffName);

    const tokenExpiresAt = new Date().getTime() + COGNITO_TIMEOUT;
    localStorage.setItem('tokenExpiration', tokenExpiresAt.toString());
    localStorage.setItem('lastActivity', Date.now().toString());

    return { ...venueData, email: normalizedEmail, staffName };
  },

  logout() {
    localStorage.clear();
  },

  isAuthenticated() {
    const isAuth = localStorage.getItem('isAuthenticated') === 'true';
    const expiration = localStorage.getItem('tokenExpiration');
    if (isAuth && expiration && Date.now() > parseInt(expiration)) {
      this.logout();
      return false;
    }
    return isAuth;
  },

  getStaffName() {
    return localStorage.getItem('staffName') || '';
  },

  getVenueName() {
    return localStorage.getItem('venueName') || '';
  },

  getUserRole() {
    return localStorage.getItem('userRole') || '';
  }
};

export default AuthService;
